import React from 'react'
import {useCartContext} from '../../../context/CartContext';
import {Divider, Grid} from '@mui/material';
import CCOHeadline from '../../fundamentals/CCOHeadline';
import {useTranslation} from 'react-i18next';
import {toCommaSeparatedDecimal} from "../../../utility/componentUtil";

interface Props {
}

function P015CartSum(props: Props) {
    const {t} = useTranslation();
    const {cartTotal, cartTotalDelivery} = useCartContext();
    return (
        <Grid container
              spacing={2}
              margin={0}
              maxWidth='100%'
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              sx={{
                  bgcolor: 'var(--background-air-white)',
                  p: {
                      xs: '8px 16px 16px 8px',
                      lg: '24px 32px 32px 24px',
                  },
              }}>
            <Grid item xs={6} display={'flex'} justifyContent={'flex-start'}>
                {t('cart.sum')!}
            </Grid>
            <Grid data-cypress={'cartSumAmount'} item xs={6} display={'flex'} justifyContent={'flex-end'}>
                {toCommaSeparatedDecimal(cartTotal)} €
            </Grid>
            <Grid item xs={6} display={'flex'} justifyContent={'flex-start'}>
                {t('cart.shipping_fee')!}
            </Grid>
            <Grid item xs={6} display={'flex'} justifyContent={'flex-end'}>
                {cartTotal > 0 ? '2,00 €' : '0,00 €'}
            </Grid>
            <Grid item xs={12}>
                <Divider variant={'fullWidth'} flexItem orientation={'horizontal'} sx={{marginY: 4}}/>
            </Grid>
            <Grid item xs={6} display={'flex'} justifyContent={'flex-start'}>
                <CCOHeadline type={'h6'} headline={t('cart.total')!}/>
            </Grid>
            <Grid item xs={6} display={'flex'} justifyContent={'flex-end'}>
                <CCOHeadline type={'h6'} headline={toCommaSeparatedDecimal(cartTotalDelivery) + ' €'}/>
            </Grid>
            <Grid item xs={12}>
                {t('cart.shipping_hint')!}
            </Grid>
        </Grid>
    )
}

export default P015CartSum